
import React from 'react';
import { VideoMetricsData } from '../hooks/types/metricsTypes';
import { DateRange } from 'react-day-picker';
import { 
  RetentionTabContent,
  ViewsTabContent,
  TrafficTabContent,
  RegionalTabContent,
  ReferenceTabContent,
  DevicesTabContent,
  DevelopmentTabContent,
  BrowsersTabContent
} from './tabs';
import { PrimeTimesTabView } from '../prime-times/PrimeTimesTabView';

interface TabContentProps {
  activeTab: string;
  isLoading: boolean;
  date?: DateRange | undefined;
  activeVideoId: string | null;
  videoMP4?: string | null;
  metricsEnhanced?: any;
}

export function TabContent({
  activeTab,
  isLoading,
  date,
  activeVideoId,
  videoMP4,
  metricsEnhanced
}: TabContentProps) {
  switch (activeTab) {
    case 'retention':
      return (
        <RetentionTabContent
          date={date}
          videoId={activeVideoId}
          videoMP4={videoMP4}
          metricsEnhanced={metricsEnhanced}
        />
      );

    case 'views':
      return (
        <ViewsTabContent
          date={date}
          videoId={activeVideoId}
          isLoading={isLoading}
          metricsEnhanced={metricsEnhanced}
        />
      );

    case 'regional':
      return (
        <RegionalTabContent
          date={date}
          videoId={activeVideoId}
          metricsEnhanced={metricsEnhanced}
        />
      );

    case 'traffic':
      return (
        <TrafficTabContent
          date={date}
          videoId={activeVideoId}
          metricsEnhanced={metricsEnhanced}
        />
      );

    case 'reference':
      return (
        <ReferenceTabContent
          date={date}
          videoId={activeVideoId}
          metricsEnhanced={metricsEnhanced}
        />
      );

    case 'prime-times':
      return (
        <PrimeTimesTabView
          date={date}
          videoId={activeVideoId}
          metricsEnhanced={metricsEnhanced}
        />
      );

    case 'devices':
      return (
        <DevicesTabContent
          date={date}
          videoId={activeVideoId}
          metricsEnhanced={metricsEnhanced}
        />
      );

    case 'browsers':
      return (
        <BrowsersTabContent
          date={date}
          videoId={activeVideoId}
          metricsEnhanced={metricsEnhanced}
        />
      );

    default:
      return null;
  }
}
